export type WorkspaceContentDeletionStatus = "active" | "requested" | "deleted" | "cleanup_failed";
export type WorkspaceContractStatus = "active" | "ended" | "paused" | "locked" | "archived";

export interface WorkspaceRetentionStatus {
  contractStatus: WorkspaceContractStatus;
  contractEndedAt?: string;
  retentionUntil?: string;
  deletionRequestedAt?: string;
  deletedAt?: string;
  deletionStatus: WorkspaceContentDeletionStatus;
}

export function calculateRetentionUntil(contractEndedAt?: string | null): string | undefined {
  if (!contractEndedAt?.trim()) return undefined;
  const date = new Date(`${contractEndedAt.slice(0, 10)}T00:00:00.000Z`);
  if (Number.isNaN(date.getTime())) return undefined;
  date.setUTCMonth(date.getUTCMonth() + 12);
  return date.toISOString().slice(0, 10);
}

export function retentionNotice(language: "de" | "en", retention?: WorkspaceRetentionStatus) {
  const body = language === "en"
    ? "Workspace content is stored for the active contract term plus 12 months. After that, it is automatically deleted unless a longer legal retention obligation applies. You can delete workspace content earlier."
    : "Workspace-Inhalte werden während der aktiven Vertragslaufzeit plus 12 Monate gespeichert. Danach werden sie automatisch gelöscht, sofern keine längere gesetzliche Aufbewahrungspflicht besteht. Sie können Workspace-Inhalte vorher selbst löschen.";
  const unknownDate = language === "en"
    ? "The planned deletion date will be calculated after the contract ends."
    : "Geplantes Löschdatum wird nach Vertragsende berechnet.";
  return {
    body,
    plannedDeletion: retention?.retentionUntil ?? unknownDate,
    deletionStatus: retention?.deletionStatus ?? "active"
  };
}

export function shouldRegisterCustomerContent(value: string | Record<string, unknown> | undefined | null): boolean {
  if (value == null) return false;
  if (typeof value === "string") return value.trim().length > 0;
  return Object.values(value).some((entry) => {
    if (typeof entry === "string") return entry.trim().length > 0;
    if (Array.isArray(entry)) return entry.length > 0;
    return entry != null;
  });
}
